import styled, { css } from "styled-components";
import { Text } from "styles/themeColors";

export const TableColumn = styled.span<any>`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  width: 234px;
  color: ${Text.secondary};
  height: 18px;
  margin-bottom: 8px;

  ${({ color }) => color && css`
  color: ${color};
`}

  ${({ width }) => width && css`
    width: ${width};
  `}


  ${({ textDecoration }) => textDecoration && css`
    text-decoration: ${textDecoration};
  `}

  ${({ fontSize }) => fontSize && css`
    font-size: ${fontSize};
  `}

  ${({ fontWeight }) => fontWeight && css`
    font-weight: ${fontWeight};
  `}

  ${({ deleted }) => deleted && css`
    opacity: 0.5;
  `}
`;